export default {
  methods: {
    exportFormatDate(value) {
      if (value === null || value === undefined || value === '') return null
      var date = new Date(value)
      if (isNaN(date.getTime())) return null
      var day = String(date.getDate()).padStart(2, '0')
      var month = String(date.getMonth() + 1).padStart(2, '0')
      return `${day}/${month}/${date.getFullYear()}`
    },
    exportTranslateLabel(key) {
      if (!key) return null
      return this.$i18n.t(key, 'it')
    },
    exportStatusDate(order, status) {
      var events = Array.isArray(order.history) ? order.history : []
      var event = events.find(
        ev => ev && ev.newStatus === status && (order.creationDate == null || ev.date > order.creationDate)
      )
      return event ? this.exportFormatDate(event.date) : null
    },
    exportClaims(claims) {
      var list = Array.isArray(claims) ? claims : claims && typeof claims === 'object' ? Object.values(claims) : []
      return list
        .filter(claim => claim && !claim.deleted)
        .map(claim => ({
          creationDate: this.exportFormatDate(claim.creationDate),
          DateCheck: this.exportFormatDate(claim.DateCheck),
        }))
    },
    buildOrderJsonExport(order) {
      var company = order.company || {}
      var shop = order.shop || {}
      var patient = order.patient || {}
      return {
        firebaseId: order.id || null,
        module: order.module || 'tailored',
        id_mercury: order.id_mercury || null,
        exportDate: this.exportFormatDate(new Date()),
        source: 'Footura',
        catalogType: order.catalogType || null,
        deliverySelected: this.exportTranslateLabel(order.deliverySelected),
        deliverySelectedSub: this.exportTranslateLabel(order.deliverySelectedSub),
        company: { mercurio_id: company.mercurio_id || null },
        shop: { mercurio_id: shop.mercurio_id || null },
        patient: { surname: patient.surname || null, name: patient.name || null },
        primaryCode: order.primaryCode || null,
        send_date: this.exportFormatDate(order.send_date),
        workord_date: this.exportStatusDate(order, 'workord'),
        claims: this.exportClaims(order.claims),
        ASLprotocol: order.ASLprotocol || null,
      }
    },
    exportWithId(order, routeId) {
      var id = order.id || (routeId && routeId != -1 ? routeId : null)
      return Object.assign({}, order, { id })
    },
    exportFileStamp() {
      var now = new Date()
      var pad = n => String(n).padStart(2, '0')
      return (
        `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}` +
        `_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
      )
    },
    exportBuildPayload(orders) {
      var exported = (orders || [])
        .filter(order => order && !order.claim)
        .map(order => this.buildOrderJsonExport(order))
      var stamp = this.exportFileStamp()
      var fileName = `Footura_GruppoOrdini_${stamp}.json`
      if (exported.length === 1) {
        var first = exported[0]
        fileName = `Footura_${first.id_mercury ? first.id_mercury : first.primaryCode}_${stamp}.json`
      }
      return { exported, fileName }
    },
    exportFormOrderJson(order, routeId) {
      this.exportOrdersJson([this.exportWithId(order, routeId)])
    },
    exportOrdersJson(orders) {
      var payload = this.exportBuildPayload(orders)
      if (payload.exported.length === 0) return
      var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(payload.exported, null, 2))
      var link = document.createElement('a')
      link.setAttribute('href', dataStr)
      link.setAttribute('download', payload.fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    sendFormOrderToMercurio(order, routeId) {
      return this.sendOrdersToMercurio([this.exportWithId(order, routeId)])
    },
    async sendOrdersToMercurio(orders) {
      var payload = this.exportBuildPayload(orders)
      if (payload.exported.length === 0) return false
      try {
        await this.$functions.httpsCallable('sendOrdersToMercurio')({
          orders: payload.exported,
          fileName: payload.fileName,
        })
        this.exportNotify('mercurio_send_success', 'is-success', 3000)
        return true
      } catch (err) {
        this.exportNotify('mercurio_send_error', 'is-danger', 5000)
        return false
      }
    },
    exportNotify(message, type, duration) {
      this.$buefy.notification.open({
        message: this.$translate(message),
        type,
        duration,
        queue: false,
      })
    },
  },
}
